// extracted by mini-css-extract-plugin
export default {"imageitem":"Icon_imageitem__XyZJX","logo":"Icon_logo__b-a4N"};